import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@interstate/components/Box';
import { CardHeader } from '@interstate/components/Card';
import { Typography } from '@interstate/components/Typography';

import { PaymentLoading } from '@makemydeal/dr-dash-components';
import { LoadingSectionParent } from '@makemydeal/dr-shared-components';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';

import { TAXES } from '../../../constants';
import { StretchHeightCard } from '../../deskingActivity/DeskingCard.style';
import TaxDetails from './TaxDetails';

/* istanbul ignore next - default parameter rarely used */
const TaxCard = ({
    isInsideSlideOut = false,
    isTaxesFormDirtyRef
}: { isInsideSlideOut?: boolean; isTaxesFormDirtyRef?: React.MutableRefObject<boolean> } = {}) => {
    const hasManualTotalTax = useSelector(offerReduxSelectors.hasManualTotalTax);

    const [taxOverrideEnabled, setTaxOverrideEnabled] = useState(hasManualTotalTax);

    useEffect(() => {
        setTaxOverrideEnabled(hasManualTotalTax);
    }, [hasManualTotalTax]);

    return (
        <LoadingSectionParent>
            <PaymentLoading testId="taxes-loading-indicator" />

            <StretchHeightCard
                className="stretch-height-card"
                data-testid="taxes-card-base"
                header={
                    /* istanbul ignore next - isInsideSlideOut typically false */
                    !isInsideSlideOut ? (
                        <CardHeader className="base-tab-title" title={<Typography variant="h3">{TAXES}</Typography>} />
                    ) : undefined
                }
                content={
                    <Box width="100%" height="100%">
                        <TaxDetails
                            taxOverrideEnabled={taxOverrideEnabled}
                            setTaxOverrideEnabled={setTaxOverrideEnabled}
                            isTaxesFormDirtyRef={isTaxesFormDirtyRef}
                        />
                    </Box>
                }
            />
        </LoadingSectionParent>
    );
};

export default TaxCard;
